 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		56: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		56: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~ActionPlans~ClientDataUpload~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~Orgnizat~6e4aefea","1":"ActionPlans~ClientDataUpload~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~OrgnizationDashb~f514fcf5","2":"ActionPlans~ClientDataUpload~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~OrgnizationDashb~ebfe099c","3":"ActionPlans~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~OrgnizationDashboard~OrgnizationR~3f20c953","4":"PreviewPoll~SchoolTeacherPoll~StudentPoll~TeacherPoll","5":"vendors~ResultsDashboard~Survey Builder~UnbecomeLoading~pdf","6":"vendors~ResultsDashboard~SuperAdmin~pdf","7":"Login~organization-page","8":"PreviewPoll","9":"ResultsDashboard","10":"vendors~ResultsDashboard","11":"vendors~Stylebook~SurveyWizard","12":"ActionPlans","13":"ChangeEmail","14":"ClientDataUpload","15":"Closed","16":"DashboardSchoolAdmin","17":"ForgotPassword","18":"Home","19":"HomepageAbout","20":"HomepageBett","21":"HomepageJobs","22":"HomepageProduct","23":"HomepageQuestions","24":"IdentitySwitcher","25":"ImportTypes","26":"Index","27":"Login","28":"Logout","29":"MetricsOverview","30":"OrgnizationDashboard","31":"OrgnizationResultsIndex","32":"PrerequisitesError","33":"ResetPassword","34":"RespondentsClasses","35":"RespondentsGroups","36":"RespondentsIndex","37":"ResultsIndex","38":"SSOManagement","39":"SchoolTeacherPoll","40":"Self Assessment Survey","41":"Self Assessment Survey Results","42":"Short Terms","43":"Skola2030","44":"StudentDashboard","45":"StudentPoll","46":"Stylebook","47":"SuperAdmin","48":"Survey Builder","49":"SurveyCreate","50":"SurveyWizard","51":"TeacherDashboard","52":"TeacherPoll","53":"Terms","54":"UnbecomeLoading","55":"UsersAbout","57":"language-table","58":"matrix-headers-modal","59":"organization-admin-organizations","60":"organization-page","61":"pdf","62":"school-admin-add-tags","63":"school-admin-schools","64":"survey-results-public-urls","65":"tokenized","66":"translations-list","67":"urlexpired","68":"vendors~ClientDataUpload"}[chunkId]||chunkId) + "-" + {"0":"cb821d9463a3d4c01348","1":"ca430c1758e25a03c2d7","2":"13c9138510d68b004f3e","3":"d8fd83e90154aa073ee8","4":"55bffd1e158a56299ca4","5":"e0a26d5e4b2fa86b269f","6":"fad786f27725555e924d","7":"610ec293239e2277ef8a","8":"57a9c7c16edc0e7b3367","9":"f0757ba02c40cd9aa3fd","10":"c8b063ed861f51ad5a75","11":"84746ded843004ffcf1d","12":"21508ec998dfcf16667c","13":"18d2e32daeacb57d1ff7","14":"942fd22b651bc4b8fe05","15":"6a5276f8e21baeaf192a","16":"69bb44461ed64a64ea7d","17":"48d9aa9d0e7d34254f2a","18":"75236c1718b1da794467","19":"09eef0d3d4f17bd4b039","20":"c3739a55282a372dc276","21":"4f2c07d9c6952f7d3507","22":"f691a35d6e06b72cd920","23":"113fd103c8cb82e8a845","24":"d5668ff785d8b3171444","25":"dc419909036387b54387","26":"8548796d9b9c6e2009ce","27":"9ab03c099b0d7c1af399","28":"87e657a7847d10d33921","29":"eb63744664f7390867cd","30":"ef016fdf63e57db1a0c4","31":"1aa379c08288cac4ee37","32":"71e6e52b7a2c39c02b7c","33":"96eb35f17db1e1e2e0d5","34":"b2c62765fcb5359f7237","35":"547d7b2f0dc19cfeeeff","36":"efdead6a79ed3933be58","37":"014a501aa5ca624fb65e","38":"282864b3f0f8034daded","39":"4c9fd7cf74939aa007b3","40":"f145a325c59892c08b16","41":"ad6c57796b578811a776","42":"b8890bc553283cd1fc57","43":"ed373c4a9339aa5797a7","44":"3e42d6171197fff02540","45":"9116cbd872f1dae3ad00","46":"cafeb689809580fb1afd","47":"bea64edf7b7aa5efbb52","48":"ce1bed67bced4b138e09","49":"f28cb6450cb06b0b2016","50":"77136ce596dab23c93b6","51":"93f913b009cc7dc07d69","52":"3f10fc3bf14ba9a4f1ce","53":"3fb576728eedecc61718","54":"8d6195da12ca963d6258","55":"e371506b0cef74ba8f50","57":"5564fa8a87ebcb46d7a5","58":"18258b5a7b769ff14529","59":"0a8c6287d17c787908bc","60":"ee8f5c28fb0d9e5a1e83","61":"409841af52fbe9f94b1b","62":"87cd9bf4a72119d1e78a","63":"bb570369ed2bdcdb2627","64":"2157a0a80416aeeba93e","65":"dc9361fe289cec9fffd3","66":"9a27733e99e7f61e71e8","67":"a0ba2c132e3453cc373e","68":"cdfcc3e2ba3bfb14d8a4","69":"7a88b41d2956a2264894","70":"00b96e6bac2419cae3f4","71":"6ead900bd9439ba8378d","72":"fa33102550c853c98429","73":"5860d8a9f6d9caecc359","74":"29c1f61f4b20de1a0f74","75":"ccf997d9e88f92cb93eb","76":"45ef24d42ab183e8988e","77":"de2bc93327813c8f32f3","78":"8b35bb45669c89d1d037","79":"92fbb7c8947ec4540851","80":"446057f0caf3aa8011aa","81":"382e7c82d391f310e698","82":"32af0f9f5a485d421d99","83":"ba3db8a9a734cf685de0","84":"27fd58e47dcd86c0bf11","85":"26fe193f3711715738c5","86":"54a5a7ed9afd8e3000c2","87":"1d479b6bfaf4c056cddb","88":"ac80467d49413ccdbde1","89":"af878f0ef02e0106b620","90":"7524c0637b174694e579","91":"4f8493f8540617e71be3","92":"0ae467a3dcf3fcb13850","93":"40b5d013eab012be16ec","94":"e578c71b9220e30c7a2c","95":"5f517bd729a939f13f3f","96":"4a1203997c93e69534d1","97":"65b3ecc6023813f43755","98":"828d9288e38770b7810d","99":"e2ed0a9964bee910e73b","100":"a81b34c797b4f1d91cc4","101":"4230f397a6f1d1fbdb8a","102":"08dc10afc2dd98a6da55","103":"6dd6a17a650096b0de1f","104":"5ac417f5d0427bd947d7","105":"a40ed9841352cd7356d5","106":"3ec55846ca66e69ed6b0","107":"6a06406872f22d9b9040","108":"8c2445d5add2f35e098c","109":"23b3229a4e57cea7ca1c","110":"a1d5a5943860dee525d4","111":"1b8eca6067f83a94e4e3","112":"18a1268d27c265834374","113":"501353d6b47dcc782fd8","114":"ee69fa8f88788dd301c5"}[chunkId] + "-chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"3":1,"4":1,"7":1,"9":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"24":1,"25":1,"26":1,"27":1,"28":1,"30":1,"31":1,"33":1,"34":1,"35":1,"36":1,"37":1,"40":1,"41":1,"42":1,"43":1,"44":1,"46":1,"47":1,"48":1,"50":1,"51":1,"53":1,"54":1,"55":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"66":1,"69":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "../material/css/build/main-stylesheet-" + {"0":"31d6cfe0d16ae931b73c","1":"fd0a26ce065213b8a815","2":"d9d785868676190bac6a","3":"763662e19a0728119d4c","4":"c80998c42fabe817e95e","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"6e96a9728c74815193a2","8":"31d6cfe0d16ae931b73c","9":"42ced5705e8b13397219","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"2424a9e3c065701d3035","13":"b305547c032f4a6c4ee1","14":"e828deea6972a8aa3412","15":"ae2608afbc401e508b59","16":"04bfbcea8944b8d2689e","17":"b305547c032f4a6c4ee1","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"4e295f58bcd887d692a5","25":"e42a12b3c8e7c419d6db","26":"b5ea0d0993b35460b3bd","27":"1804c101e609192ab5a1","28":"09c29e9ce1f11bde2d8b","29":"31d6cfe0d16ae931b73c","30":"4caeafcb441b6855831b","31":"1285883ce3dffa09204a","32":"31d6cfe0d16ae931b73c","33":"b305547c032f4a6c4ee1","34":"cf0c2ab80e649298ea63","35":"e1c26d8fd95d12558741","36":"844a47eaf875d5fa85b8","37":"1285883ce3dffa09204a","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"f4865760421016748e19","41":"fc748f1bd50e1a4de611","42":"b31d44ecf0e6705d567d","43":"c9e198da19cc9d653930","44":"d4d5c8811bed3de477ee","45":"31d6cfe0d16ae931b73c","46":"7f04e8bdbfb468ef9fdd","47":"29b1b927fa2d6f323907","48":"817c28ad709ed70e555c","49":"31d6cfe0d16ae931b73c","50":"f7770c4ff3f70333d890","51":"baaf7c42095917a70075","52":"31d6cfe0d16ae931b73c","53":"fe3e623dd55d95f2c4a5","54":"6a3623633c16bd4639ac","55":"c9e198da19cc9d653930","57":"fb34be6303bc3e3de371","58":"d934cef0d053066c1fb5","59":"836a7419d55a9e73a8a8","60":"ad99ff53188d653a1380","61":"70e0de5d794ccec5cef8","62":"5001f28753851ae5752f","63":"63c142b007e5002a6aef","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"3a3849ee951af21d37a5","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"11196146f234db879a4a","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c","87":"31d6cfe0d16ae931b73c","88":"31d6cfe0d16ae931b73c","89":"31d6cfe0d16ae931b73c","90":"31d6cfe0d16ae931b73c","91":"31d6cfe0d16ae931b73c","92":"31d6cfe0d16ae931b73c","93":"31d6cfe0d16ae931b73c","94":"31d6cfe0d16ae931b73c","95":"31d6cfe0d16ae931b73c","96":"31d6cfe0d16ae931b73c","97":"31d6cfe0d16ae931b73c","98":"31d6cfe0d16ae931b73c","99":"31d6cfe0d16ae931b73c","100":"31d6cfe0d16ae931b73c","101":"31d6cfe0d16ae931b73c","102":"31d6cfe0d16ae931b73c","103":"31d6cfe0d16ae931b73c","104":"31d6cfe0d16ae931b73c","105":"31d6cfe0d16ae931b73c","106":"31d6cfe0d16ae931b73c","107":"31d6cfe0d16ae931b73c","108":"31d6cfe0d16ae931b73c","109":"31d6cfe0d16ae931b73c","110":"31d6cfe0d16ae931b73c","111":"31d6cfe0d16ae931b73c","112":"31d6cfe0d16ae931b73c","113":"31d6cfe0d16ae931b73c","114":"31d6cfe0d16ae931b73c"}[chunkId] + "-chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/vue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 284);
